module.exports = __webpack_public_path__ + "static/img/备案图标.d0289dc.png";


//////////////////
// WEBPACK FOOTER
// ./static/pc/备案图标.png
// module id = hReD
// module chunks = 0